import React from "react";
import {FaArrowLeft, FaLock, FaPen, FaUsers, FaXmark} from "react-icons/fa6";
import Button from "../../../components/button";

const BoardHeader = ({board, onBack, isSaving, isEditing, editingUser, onStartEditing, onStopEditing, isChangingEditing}) => (
    <div className="flex flex-col gap-4 border-b border-slate-200 bg-white px-5 py-4 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex min-w-0 items-start gap-3">
            <Button type="button" onClick={onBack} title="Voltar para os quadros" col="mt-0.5 !h-8 !w-8 !px-0"><FaArrowLeft /></Button>
            <div className="min-w-0">
                <div className="flex items-center gap-2">
                    <span className="h-6 w-1 rounded-full bg-blue-600" />
                    <h1 className="truncate text-xl font-bold text-slate-800">{board.name}</h1>
                </div>
                <p className="mt-1 flex items-center gap-1 pl-3 text-xs text-slate-500">
                    {board.visibility === "shared" ? <><FaUsers /> Compartilhado com {board.sharedUsers?.length ?? 0} usuário(s)</> : <><FaLock /> Quadro privado</>}
                </p>
            </div>
        </div>

        <div className="flex items-center gap-3">
            {editingUser && !isEditing && <span className="text-xs font-medium text-amber-600">{editingUser.name} está editando</span>}
            {isSaving && <span className="text-xs font-medium text-slate-400" role="status">Salvando alterações...</span>}
            {board.canEditContent && (isEditing
                ? <Button type="button" onClick={onStopEditing} disabled={isChangingEditing || isSaving}><FaXmark /> Finalizar edição</Button>
                : <Button type="button" target="primary" onClick={onStartEditing} disabled={Boolean(editingUser) || isChangingEditing}><FaPen /> Editar</Button>)}
        </div>
    </div>
);

export default BoardHeader;
